/**
 * @generated SignedSource<<417ba31be863fe1d2062d6a0c076ba58>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedTopHeroBannerModule_user$data = {
  readonly serviceId: string | null;
  readonly " $fragmentType": "HpSharedTopHeroBannerModule_user";
};
export type HpSharedTopHeroBannerModule_user$key = {
  readonly " $data"?: HpSharedTopHeroBannerModule_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedTopHeroBannerModule_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedTopHeroBannerModule_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "5025e41f5001353893d76e729c20a694";

export default node;
